export default __webpack_public_path__ + "static/Sticker-CertifiedUsedCars-blue~FGvFuLFe-95f5a2ca98167253e326db4aa9fedb22.png";